module.exports = __webpack_public_path__ + "img/doctorsHat.412180d4.svg";